import { RootState } from "../hooks";

export const getAllPostsSelector = (state: RootState) => state.allPosts;
